module.exports = __webpack_public_path__ + "static/media/recommend4.7d005505.png";